import produce from "immer";
import first from "lodash/first";
import pullAllBy from "lodash/pullAllBy";
import { CustomizationState } from "..";
import { checkAndFillInitialPages } from "../../../utils/customization/content";
import { addPageMutation, generateNewPage } from "../../../utils/customization/page";

export interface RemoveSelectedPagesAction {
  type: "removeSelectedPages";
  pageKeys: string[];
}

export function removeSelectedPages(
  state: CustomizationState,
  action: RemoveSelectedPagesAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { pageKeys } = action;
    const { content, template } = draftState;

    pullAllBy(
      content.pages,
      pageKeys.map((pageKey) => {
        return { key: pageKey };
      }),
      "key"
    );

    checkAndFillInitialPages(content, template);

    if (content.pages.length === 0) {
      const firstTemplatePageDefinition = first(template.pageDefinitions);
      if (!firstTemplatePageDefinition) {
        return;
      }
      const newPage = generateNewPage(firstTemplatePageDefinition.key, template);
      addPageMutation(newPage, content);
    }
  });
}
